import { faArrowUp } from '@fortawesome/free-solid-svg-icons';
import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { EventVideoViewModel } from 'stageclip-common';

import { createAllEventVideosRequestedAction } from '../../../actions/eventVideosActions';
import { DataRequestActionTypes } from '../../../constants/actionTypes';
import { FormId } from '../../../constants/formId';
import { processAegisubResult } from '../../../helpers/aegisubHelper';
import { ClippingPlatformState } from '../../../store/clippingPlatformState';
import { getAllWithIds, getItem } from '../../../store/selectors';
import {
  baseMapDispatchToProps,
  baseMapStateToProps,
  ComponentBase,
  BaseDispatchProps,
  BaseStateProps,
} from '../../componentBase';
import { AppSelectField } from '../../form/appSelectField';
import { AppTextAreaField } from '../../form/appTextAreaField';
import { required } from '../../form/formValidations';
import FormModal from '../../modal/formModal';

import styles from './uploadParticipantsForm.module.scss';

interface UploadParticipantsFormOwnProps {
  eventId: string;
}

interface UploadAegisubResultFormStateProps extends BaseStateProps {
  eventVideos: EventVideoViewModel[];
  submitErrors: any;
}

interface UploadAegisubResultFormDispatchProps extends BaseDispatchProps {
  loadAllEventVideos: (c: UploadAegisubResultForm) => void;
}

class UploadAegisubResultForm extends ComponentBase<
  UploadParticipantsFormOwnProps,
  UploadAegisubResultFormStateProps,
  UploadAegisubResultFormDispatchProps
> {
  protected dataLoaded(props: any) {
    return props.eventVideos;
  }

  protected async loadData(props: any) {
    await props.loadAllEventVideos(this);
  }

  protected loggedInRender() {
    const preprocessDataOnSubmit = (formData: any) => {
      return {
        ...formData,
        aegisubResult: processAegisubResult(formData.aegisubResult),
      };
    };

    return (
      <FormModal
        formId={FormId.UploadAegisubResult}
        formTitle="Upload Aegisub Result"
        submitActionType={DataRequestActionTypes.UploadAegisubResultRequested}
        reduxData={{ eventId: this.props.eventId }}
        buttonIcon={faArrowUp}
        invertedButtonColours
        preprocessDataOnSubmit={preprocessDataOnSubmit}
      >
        {this.renderSubmitFieldErrors()}
        <div className={styles.warning}>
          Please note this will replace data for participants. Rows with no interval will be ignored.
        </div>
        <AppSelectField
          name="eventVideoId"
          options={this.getEventVideosOptions()}
          label="Event Video"
          validate={[required]}
        />
        <AppTextAreaField name="aegisubResult" label="Aegisub result" validate={[required]} />
      </FormModal>
    );
  }

  private getEventVideosOptions() {
    return this.props.eventVideos.map(ev => ({ value: ev.id, label: ev.name }));
  }

  private renderSubmitFieldErrors() {
    if (!this.props.submitErrors) {
      return undefined;
    }

    const erredFields = Object.keys(this.props.submitErrors).filter(e => e !== '_message');

    return erredFields ? (
      <div className={styles.error}>
        {erredFields.map(fieldName => (
          <div key={fieldName}>{this.props.submitErrors[fieldName]}</div>
        ))}
      </div>
    ) : (
      undefined
    );
  }
}

function mapStateToProps(
  state: ClippingPlatformState,
  ownProps: UploadParticipantsFormOwnProps,
): UploadAegisubResultFormStateProps {
  const event = getItem(state.entities.events, ownProps.eventId);

  return {
    ...baseMapStateToProps(state),
    eventVideos: getAllWithIds(state.entities.eventVideos, event.eventVideos),
    submitErrors: state.form[FormId.UploadAegisubResult]
      ? state.form[FormId.UploadAegisubResult].submitErrors
      : undefined,
  };
}

function mapDispatchToProps(
  dispatch: Dispatch,
  ownProps: UploadParticipantsFormOwnProps,
): UploadAegisubResultFormDispatchProps {
  return {
    ...baseMapDispatchToProps(dispatch),
    loadAllEventVideos: (c: UploadAegisubResultForm) =>
      dispatch(createAllEventVideosRequestedAction(ownProps.eventId, c, dispatch)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(UploadAegisubResultForm);
